import {
  DeviceConfig1Message,
  DeviceConfig2Message,
  DeviceConfig3Message,
  DeviceConfig4Message,
  DeviceConfig5Message,
  SntsMessage,
  SchdMessage,
  TestMessage,
  SensorConfig1Message,
  parseMessage,
} from '../decoders'
import { Devices } from '../common'
import { TMessageSigfoxOut } from '../entities/ric003'
import { DeviceData } from '../models/deviceState'
import { hexStringToArrayBuffer } from '../common/utils'
import { SensorType, SigfoxMessageType } from '../common/enums'
import { battery, temperature } from '../converters'
// import { checkForAlerts } from './alerts'

import { addReading, interpretScheduledReading } from './readings'
// import { isLongEnoughToExitConfigMode } from './configMode'
import { decodeSensor } from './sensors'
import { log } from './logger'

export function processMessagesForSingleDevice(
  device: DeviceData,
  messages: TMessageSigfoxOut[]
) {
  for (var i = 0; i < messages.length; i++) {
    const message = messages[i]

    const decodedMessage = parseMessage(message.MSG_CONTENT)

    if (device && message.SIGFOX_ID === device.sigfoxId) {
      updateDevices(
        device,
        message,
        hexStringToArrayBuffer(message.MSG_CONTENT)[0],
        decodedMessage
        // connections
      )
    }
  }
}

export function processMessages(
  devices: Devices,
  messages: TMessageSigfoxOut[]
) {
  for (var i = 0; i < messages.length; i++) {
    const message = messages[i]
    const device = devices[message.SIGFOX_ID]

    if (device) {
      const decodedMessage = parseMessage(message.MSG_CONTENT)

      updateDevices(
        device,
        message,
        hexStringToArrayBuffer(message.MSG_CONTENT)[0],
        decodedMessage
      )
    }
  }
}

function updateDevices(
  device: DeviceData,
  message: TMessageSigfoxOut,
  messageType: number,
  decodedMessage: any
  // connections: Connections
): boolean {
  var storeSnapshot = false

  // [ALR] this is a side-effect because we are accessing global
  // const config = devices[deviceId].data.config
  var parsed = true
  var configUpdate = true

  switch (messageType) {
    case SigfoxMessageType.TestMessage:
      const testMessage = decodedMessage as TestMessage
      device.state.test.message = testMessage.message
      device.tracking.timestamps.testMessage = message.SIGFOX_TIME

      log(
        message.MSG_RAW_ID,
        message.SIGFOX_ID,
        message.DATE_CREATE,
        message.MSG_CONTENT,
        'test messages',
        message.SIGFOX_TIME,
        testMessage.message
      )

      configUpdate = false

      addReading(device, message, 'Messages', testMessage.message)
      break

    case SigfoxMessageType.SeqNumTimestamp:
      const snts = decodedMessage as SntsMessage
      device.state.readings.battery = battery(snts.batteryReading)
      device.state.alerts.batteryLowWarning = snts.flagPowerIsBelowWarningLevel
      device.state.alerts.batteryLowShutdown =
        snts.flagPowerIsBelowShutdownLevel
      device.tracking.timestamps.sntsMessage = message.SIGFOX_TIME
      configUpdate = false

      log(
        message.MSG_RAW_ID,
        message.SIGFOX_ID,
        message.DATE_CREATE,
        message.MSG_CONTENT,
        'seq num timestamp',
        'battery ------------------------->',
        device.state.readings.battery + 'V'
      )

      addReading(
        device,
        message,
        SensorType.Battery,
        device.state.readings.battery
      )
      break

    case SigfoxMessageType.ScheduledReading:
      if (
        device.tracking.configUpdate.active === true
        // && isLongEnoughToExitConfigMode(device, message)
      ) {
        device.tracking.configUpdate.active = false
        device.tracking.configUpdate.configured = true
        storeSnapshot = true

        log(
          message.MSG_RAW_ID,
          message.SIGFOX_ID,
          message.DATE_CREATE,
          message.MSG_CONTENT,
          'scheduled reading -------------------------> STORE SNAPSHOT',
          message.SIGFOX_TIME - device.tracking.configUpdate.lastUpdate
        )
      }

      if (device.tracking.configUpdate.configured) {
        const schd = decodedMessage as SchdMessage

        device.state.readings.temperature = temperature(schd.temperature)
        device.state.alerts.batteryLowWarning =
          schd.flagPowerIsBelowWarningLevel
        device.state.alerts.batteryLowShutdown =
          schd.flagPowerIsBelowShutdownLevel
        device.tracking.timestamps.schdMessage = message.SIGFOX_TIME

        const readings = interpretScheduledReading(device, schd)

        log(
          message.MSG_RAW_ID,
          message.SIGFOX_ID,
          message.DATE_CREATE,
          message.MSG_CONTENT,
          'scheduled reading',
          'raw temperature =',
          schd.temperature,
          'converted temperature =',
          device.state.readings.temperature + 'C',
          readings
        )

        configUpdate = false

        addReading(
          device,
          message,
          SensorType.Temperature,
          device.state.readings.temperature
        )

        Object.keys(readings).map((sensor) => {
          if (
            device.config.sensors[sensor].enabled &&
            device.config.sensors[sensor].sensorType !== SensorType.None &&
            device.config.sensors[sensor].sensorType !== SensorType.Unknown
          ) {
            addReading(device, message, sensor, readings[sensor])
            // checkForAlerts({
            //   device,
            //   message,
            //   sensor,
            //   thresholds: device.config.sensors[sensor].thresholds,
            //   reading: readings[sensor],
            // })
          }
        })
      }
      break

    case SigfoxMessageType.DeviceConfig1:
      const config1 = decodedMessage as DeviceConfig1Message
      device.config.frequency.snts = config1.sntsFrequency
      device.config.frequency.schd = config1.schdFrequency
      device.config.location.coordinateType = config1.coordinateType
      device.config.location.coord.ns = config1.locationNSValue
      device.config.location.coord.ew = config1.locationEWValue
      device.tracking.timestamps.deviceConfig1 = message.SIGFOX_TIME
      log(
        message.MSG_RAW_ID,
        message.SIGFOX_ID,
        message.DATE_CREATE,
        message.MSG_CONTENT,
        '> device config 1'
      )
      break

    case SigfoxMessageType.DeviceConfig2:
      const config2 = decodedMessage as DeviceConfig2Message
      device.config.firmwareVersion = config2.firmwareVersion
      device.config.location.coord.z = config2.locationZValue
      device.config.location.coord.gridZone = config2.locationGridZone
      device.tracking.timestamps.deviceConfig2 = message.SIGFOX_TIME
      log(
        message.MSG_RAW_ID,
        message.SIGFOX_ID,
        message.DATE_CREATE,
        message.MSG_CONTENT,
        '> device config 2'
      )
      break

    case SigfoxMessageType.DeviceConfig3:
      const config3 = decodedMessage as DeviceConfig3Message
      device.config.device.mode = config3.deviceAppMode
      device.config.device.pin = config3.devicePin
      device.tracking.timestamps.deviceConfig3 = message.SIGFOX_TIME
      log(
        message.MSG_RAW_ID,
        message.SIGFOX_ID,
        message.DATE_CREATE,
        new Date(message.SIGFOX_TIME * 1000),
        message.MSG_CONTENT,
        '               ',
        '> device config 3'
      )
      break

    case SigfoxMessageType.DeviceConfig4:
      const config4 = decodedMessage as DeviceConfig4Message
      device.config.location.description = config4.locationNamePart1
      device.tracking.timestamps.deviceConfig4 = message.SIGFOX_TIME
      log(
        message.MSG_RAW_ID,
        message.SIGFOX_ID,
        message.DATE_CREATE,
        message.MSG_CONTENT,
        '> device config 4'
      )
      break

    case SigfoxMessageType.DeviceConfig5:
      const config5 = decodedMessage as DeviceConfig5Message
      device.config.location.description += config5.locationNamePart2
      device.tracking.timestamps.deviceConfig5 = message.SIGFOX_TIME
      log(
        message.MSG_RAW_ID,
        message.SIGFOX_ID,
        message.DATE_CREATE,
        message.MSG_CONTENT,
        '> device config 5'
      )
      break

    case SigfoxMessageType.SensorConfig1:
      device.tracking.timestamps.sensorConfig1 = message.SIGFOX_TIME
      const sensorConfig = decodedMessage as SensorConfig1Message
      device.config.sensors = decodeSensor(device.config.sensors, sensorConfig)
      log(
        message.MSG_RAW_ID,
        message.SIGFOX_ID,
        message.DATE_CREATE,
        message.SIGFOX_TIME,
        message.MSG_CONTENT,
        '> sensor config',
        sensorConfig.sensorNumber,
        sensorConfig.sensorPort,
        sensorConfig.sensorType
      )
      break

    default:
      parsed = false
      configUpdate = false
      break
  }

  if (parsed) {
    device.tracking.last.rawMessageId = message.MSG_RAW_ID
    device.tracking.last.update = message.SIGFOX_TIME
  }

  if (configUpdate) {
    device.tracking.configUpdate.active = true
    device.tracking.configUpdate.lastUpdate = message.SIGFOX_TIME
  }

  return storeSnapshot
}
